module.exports = __webpack_public_path__ + "img/ic_take_picture.3b9a9143.png";